import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/cover_photo_babe.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "ion-text-center ion-padding-bottom" }, "設計訂造", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "ion-text-center ion-padding-bottom" }, "專屬您的寵物芭比娃娃", -1)
const _hoisted_3 = { class: "ion-margin-top" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('馬上開始訂造') + " ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "小 小 展 覽 館", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "關 於 我 們", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title-underline" }, null, -1)
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, { hideIcons: true }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-text-center",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_slides, { homeBanners: true }),
              _createVNode(_component_ion_item_divider),
              _createElementVNode("div", null, [
                _hoisted_1,
                _hoisted_2,
                _createElementVNode("img", {
                  class: "main-img",
                  style: {"border-radius":"25px"},
                  src: _imports_0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openImageModal(require('@/assets/cover_photo_babe.jpg'))))
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_button, {
                    color: "primary",
                    shape: "round",
                    size: "large",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openBabeOrderModal()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: $setup.enterOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_ion_item_divider),
              _createVNode(_component_ion_text, { color: "primary" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _hoisted_6,
              _createVNode(_component_slides, { photoLinks: $setup.demoPhotoLinks }, null, 8, ["photoLinks"]),
              _createVNode(_component_ion_item_divider),
              _createVNode(_component_ion_text, { color: "primary" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _hoisted_8,
              _createVNode(_component_ion_card, { class: "no-border-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ion-text-center",
                        style: {"white-space":"pre-line","font-size":"15px"},
                        innerHTML: $setup.settings['關於我們']
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}